import {makeStyles} from "@material-ui/styles";

const modalTop = 50
const modalLeft = 50

export default makeStyles(theme => ({
    modalRoot: {
        maxWidth: '50%',
        top: `${modalTop}%`,
        left: `${modalLeft}%`,
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        transform: `translate(-${modalTop}%, -${modalLeft}%)`,
        [theme.breakpoints.only("xs")]: {
            maxWidth: '95%',
            width: '95%',
            padding: theme.spacing(1, 1, 1),
        },
        outline: 'none',
    },
    modalExit: {
        position: 'absolute',
        top: 5,
        right: 5
    },
}));